import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { DataTable } from "@/components/DataTable";
import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { IWorkOrderLifecycle } from "@/data/work-orders";
import { Flex } from "@/eworkitComponents/components";
import { useFormats } from "@/hooks/Formats";

export interface IWorkOrderDetailsLifecycleTableProps {
  lifecycles: IWorkOrderLifecycle[];
}

export const WorkOrderDetailsLifecycleTable: FC<IWorkOrderDetailsLifecycleTableProps> = memo(({ lifecycles }) => {
  const { t } = useTranslation("session");
  const { formatDate } = useFormats();

  return (
    <DataTable<IWorkOrderLifecycle>
      data={lifecycles}
      columns={[
        {
          header: t("WORK_ORDERS.DETAILS.LIFECYCLE_DETAILS.ACTIVITY_TYPE_TABLE_HEADER"),
          selector: (data: IWorkOrderLifecycle) => (
            <Flex innerMargin="sm">
              <Icon icon="checkbox" size="md" />
              <Text wordBreak="word" whiteSpace="pre-wrap">
                {t(`WORK_ORDERS.DETAILS.LIFECYCLE_DETAILS.ACTIVITY_TYPE.${data.activityType}`, {
                  username: data.arg1,
                })}
              </Text>
            </Flex>
          ),
          flexGrow: 1,
        },
        {
          header: t("WORK_ORDERS.DETAILS.LIFECYCLE_DETAILS.WHO_TABLE_HEADER"),
          selector: (data: IWorkOrderLifecycle) =>
            ["TASK_APPROVED", "TASK_REJECTED"].includes(data.activityType) ? (
              <Text wordBreak="all" whiteSpace="pre-wrap">
                {data.arg1 ?? ""}
              </Text>
            ) : (
              ""
            ),
          flexGrow: 1,
          maxWidth: "220px",
        },
        {
          header: t("WORK_ORDERS.DETAILS.LIFECYCLE_DETAILS.WHEN_TABLE_HEADER"),
          selector: (data: IWorkOrderLifecycle) => formatDate(data.createdDate),
          flexGrow: 1,
          maxWidth: "150px",
        },
      ]}
      uniqueKeyAccessor="id"
    />
  );
});
